.empty {
  padding: 22px var(--pad);
  font-size: 14px;
  color: var(--muted);
  text-align: center;
}

/* Возврат — это движение денег в обратную сторону, и цветом он отличается
   от покупки: иначе минус перед суммой остаётся единственным признаком. */
.refund {
  color: var(--danger);
}
